var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.517 4.25308C20.3271 3.91921 19.9696 3.72607 19.5941 3.72607L3.33541 3.73789C2.88262 3.73793 2.49006 4.01757 2.33313 4.43424L2.33299 4.43464C2.22001 4.7359 2.24534 5.06456 2.40046 5.33601L2.40263 5.3398L2.40491 5.34353C2.46328 5.43906 2.53741 5.52904 2.6272 5.60826L8.81581 10.945L10.3242 18.9575L10.3243 18.958C10.4067 19.4019 10.7504 19.7325 11.1959 19.8031C11.6368 19.8737 12.0708 19.666 12.2974 19.283L12.2977 19.2824L20.5114 5.31992L20.3291 5.00319C20.3291 5.00307 20.3292 5.00294 20.3292 5.00281L20.5116 5.31956C20.7072 4.98777 20.7083 4.58235 20.517 4.25308ZM19.7776 4.04474L19.5941 3.72607L19.7775 4.04472C19.7775 4.04473 19.7775 4.04474 19.7776 4.04474ZM9.74578 9.39029L5.24076 5.50143H16.5606L9.74578 9.39029ZM11.7226 16.7558L10.6245 10.9214L17.4526 7.02729L11.7226 16.7558Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareInstagram);
export default __webpack_public_path__ + "static/media/share_instagram.3a8eaa3769b42a7618c4468a7d2346df.svg";
export { ForwardRef as ReactComponent };